import React, { useState } from 'react';
import { Mail, Send, MapPin } from 'lucide-react';
import { toast } from 'sonner';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error('Please fill out all fields.');
      return;
    }
    toast.success('Message received. Our team will respond within 1 business day.');
    setForm({ name: '', email: '', message: '' });
  };

  return (
    <section id="contact" className="relative border-t border-[rgba(201,162,75,0.10)]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14">
          <div>
            <p className="text-[10px] tracking-[0.25em] font-mono gold-text">CONTACT</p>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-[1.05]">
              Talk to the team
              <br />
              <span className="gold-text">operating the platform.</span>
            </h2>
            <p className="mt-6 text-[#CDBE94] leading-relaxed max-w-md">
              Questions about broker support, subscription tiers, or platform behavior — send a note and we’ll route it to the right operator.
            </p>
            <div className="mt-10 space-y-5">
              <div className="flex items-start gap-4">
                <div className="w-9 h-9 border gold-border rounded-sm flex items-center justify-center shrink-0">
                  <Mail size={14} className="gold-text" strokeWidth={1.6} />
                </div>
                <div>
                  <p className="text-[10px] tracking-widest font-mono text-[#A99563]">EMAIL</p>
                  <p className="text-sm text-[#F1ECDF] mt-1">tspeichingeriii@gmail.com</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-9 h-9 border gold-border rounded-sm flex items-center justify-center shrink-0">
                  <MapPin size={14} className="gold-text" strokeWidth={1.6} />
                </div>
                <div>
                  <p className="text-[10px] tracking-widest font-mono text-[#A99563]">JURISDICTION</p>
                  <p className="text-sm text-[#F1ECDF] mt-1">Lincoln County, Missouri · United States</p>
                </div>
              </div>
            </div>
          </div>

          <form
            onSubmit={handleSubmit}
            className="border border-[rgba(201,162,75,0.16)] rounded-md p-8 bg-[#0c0c0e]"
          >
            <div>
              <label className="text-[10px] tracking-widest font-mono text-[#CDBE94]">NAME</label>
              <input
                type="text"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="mt-2 w-full bg-transparent border border-[rgba(201,162,75,0.16)] rounded-sm px-4 py-3 text-sm text-white focus:outline-none focus:border-[#d8b34a]/60"
                placeholder="Your name"
              />
            </div>
            <div className="mt-5">
              <label className="text-[10px] tracking-widest font-mono text-[#CDBE94]">EMAIL</label>
              <input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="mt-2 w-full bg-transparent border border-[rgba(201,162,75,0.16)] rounded-sm px-4 py-3 text-sm text-white focus:outline-none focus:border-[#d8b34a]/60"
                placeholder="you@email.com"
              />
            </div>
            <div className="mt-5">
              <label className="text-[10px] tracking-widest font-mono text-[#CDBE94]">MESSAGE</label>
              <textarea
                rows={5}
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                className="mt-2 w-full bg-transparent border border-[rgba(201,162,75,0.16)] rounded-sm px-4 py-3 text-sm text-white focus:outline-none focus:border-[#d8b34a]/60 resize-none"
                placeholder="How can we help?"
              />
            </div>
            <button
              type="submit"
              className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-[#d8b34a] text-black font-medium text-sm rounded-sm hover:bg-[#e6c365] transition-colors"
            >
              Send Message
              <Send size={14} />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
